import { render, staticRenderFns } from "./GroupApproveModal.vue?vue&type=template&id=54e19b0e&scoped=true"
import script from "./GroupApproveModal.vue?vue&type=script&lang=js"
export * from "./GroupApproveModal.vue?vue&type=script&lang=js"
import style0 from "./GroupApproveModal.vue?vue&type=style&index=0&id=54e19b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e19b0e",
  null
  
)

export default component.exports